import React, { FunctionComponent } from 'react';

import { Nav } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';

import { route, isNewStackRoute } from 'core/util/Routing';

export interface Props {
    path: string;
    newTab?: boolean;
    [x: string]: any;
}

export const AppLink: FunctionComponent<Props> = ({ path, newTab, ...others }) => {
    if (newTab) {
        return <Nav.Link {...others} href={path} target="_blank" />;
    }

    if (isNewStackRoute(path)) {
        return <Nav.Link {...others} as={NavLink} to={path} href={route(path)} />;
    }

    return <Nav.Link {...others} href={route(path)} />;
};
